export default "__VITE_ASSET__DzWt1Kht__"